import { gql } from "@apollo/client";

export const MAPPABLE_OFFICERS = gql`
  query MAPPABLE_OFFICERS($oriIds: String!, $originatorId: ID!) {
    mappableOfficers(
      oriIds: $oriIds
      originatorId: $originatorId
      noSessionReset: true
    ) {
      id
      lat
      lng
      accuracy
      locationUpdatedAt
      locationSource
      personalAttribute {
        id
        lastName
        middleName
        firstName
      }
      deptAttribute {
        onDuty
        badge
        carNumber
        id
        radioNumber
        status
        ori {
          abbreviation
        }
      }
    }
  }
`;
